import React from 'react';

import { Button } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import commonStyles from '../../common/common.module.css';
import driverStyle from './driverQueue.module.css';

import fdLogo from '../../../assets/fd_text_logo.png';

const styles = (theme: Theme) =>

  createStyles({
    
  });

  interface CheckInSuccessPageProps {
  classes: any;
  ghaName: string;
  changeScreen: Function;
};

const checkInSuccessPage = (props: CheckInSuccessPageProps) => {

 return (
    <div className={ driverStyle.pageWrapper }>
      <div className={ driverStyle.logoWrapper }> 
        <img alt="frontline dynamics logo" src={ fdLogo } className={ driverStyle.logoImg } />
        <div className={ driverStyle.ghaName }>{ props.ghaName } </div>
      </div>

      <div className={ driverStyle.content }>
        <div>
          <p className={` ${ commonStyles.textCenter } ${ commonStyles.mb4 } `}>You have checked in successfully!</p>
          <Button 
            color="primary" 
            variant="contained"
            className={` ${ driverStyle.button } ${ commonStyles.w100 } `}
            onClick={ () => props.changeScreen('home') }
          > 
            Close
          </Button>
        </div>

      </div> 
        
    </div>
  );
}

export default withStyles(styles)(checkInSuccessPage);